import React, {Fragment} from "react";
import HeaderBar from "../containers/header/HeaderBar";

export default function Layout(props: { children: any, title: string }) {

    return (
        <Fragment>
            <HeaderBar title={props.title}/>

            <div className={"mr-3 ml-3"}>
                {props.children}
            </div>
        </Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Layout.js